module.exports = __webpack_public_path__ + "media/unipod/capacity_output-b00f1a1b.jpg";